import React from "react";
import PersonAdaptToClient from "@parts/person/personAdaptToClient";
import { checkIfBranchExists } from "../../../../utils";
import NoCertificateWarning from "../../../../views/AppViews/_components/NoCertificateWarning";

export default class CreateClient extends React.Component {
  constructor(props) {
    super(props);
    checkIfBranchExists()
    this.state = {};
    this.save = this.save.bind(this);
  }
  save(client) {
    window.location.href = "/clients";
  }

  UNSAFE_componentWillMount() {}
  render() {
    return (
      <div>
        <NoCertificateWarning />
        <PersonAdaptToClient onSaveClient={this.save} />
      </div>
    );
  }

  componentWillUnmount() {}
}



// WEBPACK FOOTER //
// ./src/components/pages/clients/create/index.jsx